// extracted by mini-css-extract-plugin
export default {"card":"P1-z","carouselContainer":"Q1-z","carouselContent":"R1-z"};